import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import api from '../../services/api'
import { IEvent } from '../../interfaces/IEvent'
import EventConsolidatedReportPrinting from './EventResult/EventConsolidatedReportPrinting'
import { AuthContext } from '../../context/AuthContext'

export default function EventList() {
  const { authUser } = useContext(AuthContext)
  const [events, setEvents] = useState<IEvent[]>([])
  const [printingEventId, setPrintingEventId] = useState<number | null>(null)
  const [printingEventTitle, setPrintingEventTitle] = useState<string>('')
  const navigate = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    api.get('/api/events/competition/' + id).then((resposta) => setEvents(resposta.data))
  }, [])

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <h3 className="mb-2">
            <b>Provas</b>
          </h3>
        </div>
      </div>
      <div className="row my-4">
        {events.map((test) => (
          <div key={test.id} className="col-md-4 mt-3">
            <div className="card">
                {(['admin'].includes(authUser?.role)) && (
                    <div className="col-sm-6 my-1">
                        <Link to={`/events/edit/${test.id}`} className="btn btn-warning btn-sm position-absolute end-0 ">
                            <i className="bi bi-pencil">&nbsp;</i>
                    </Link>
                    </div>
                )}
                {test.image && (
                    <img className={test.status === 'finished' ? 'card-img-top img-blur' : 'card-img-top'} src={!test.image?"/logo192.png": test.image} style={{maxHeight:'240px'}} alt="Logo prova" />
                )}
              <div className="card-body">
                <h4 className="card-title">{test.title}</h4>
                <p className="card-text">{test.description}</p>

                <div className="row">
                  {test.status !== 'finished' && (
                    <>
                      <div className="col-sm-6 my-1">
                        <Link to={'/event-stages/' + test.id} className="btn btn-primary w-100"><i className="bi bi-clipboard-data">&nbsp;</i> Acessar</Link>
                      </div>
                    </>
                  )}

                  {(test.status === 'finished' || test.show_result) && (
                    <div className="col-sm-6 my-1 ">
                      <button className="btn btn-success w-100"
                        onClick={() => {
                          setPrintingEventId(test.id)
                          setPrintingEventTitle(test.title)
                        }}
                      >
                        <i className="bi bi-trophy-fill">&nbsp;</i>Resultados
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {printingEventId && (
        <EventConsolidatedReportPrinting
          key={printingEventId}
          eventId={printingEventId}
          eventTitle={printingEventTitle}
          childToParent={() => setPrintingEventId(null)}
        />
      )}

      <div className="row">
        <div className="col-md-12 text-right">
          <button className="btn btn-danger btn-floating" onClick={() => navigate(`/competitions`)}>Voltar<br /></button>
        </div>
      </div>
    </>
  )
}
